import { render } from "./App.vue?vue&type=template&id=50853b95"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=50853b95&lang=css"
import "./App.vue?vue&type=style&index=1&id=50853b95&lang=scss"
script.render = render

export default script